export default "__VITE_ASSET__DwescVNa__"